export default "__VITE_ASSET__CdcLCPUh__"